// Страницы настроек
export const PAGE_TITLE_SETTINGS_PAYMENT = 'Способы оплаты';
export const PAGE_TITLE_SETTINGS_MANAGERS = 'Пользователи и роли';
export const PAGE_TITLE_SETTINGS_ABOUT = 'О компании';
export const PAGE_TITLE_SETTINGS_YCP_API = 'Подключение к API YCP';
export const PAGE_TITLE_SETTINGS_BITRIX = 'Подключение к модулю 1С-Битрикс';
export const PAGE_TITLE_SETTINGS_SEO = 'SEO';
export const PAGE_TITLE_SETTINGS_DOMAIN = 'Домен';
export const PAGE_TITLE_SETTINGS_CHARACTERISTICS = 'Характеристики';
export const PAGE_TITLE_SETTINGS_PRODUCT_FEED = 'Тестирование фида';
export const PAGE_TITLE_SETTINGS_LOGISTICS = 'Склады и логистика';
export const PAGE_TITLE_SETTINGS_INVENTORY = 'Товары, цены, остатки';
export const PAGE_TITLE_SETTINGS_INTEGRATIONS = 'Интеграции';
export const PAGE_TITLE_SETTINGS_YA_METRIKA = 'Яндекс Метрика';
export const PAGE_TITLE_SETTINGS_BUY_BUTTON = 'Кнопка «Купить в 1 клик» на\u00A0сайте';
export const PAGE_TITLE_SETTINGS_ORDER = 'Заказы';
export const PAGE_TITLE_SETTINGS_BADGES = 'Бейджи';
export const PAGE_TITLE_SETTINGS_FEEDBACK = 'Отзывы';
export const PAGE_TITLE_SETTINGS_EMAIL_NOTIFICATIONS = 'Почтовые уведомления';
export const PAGE_TITLE_SETTINGS_ORDER_NOTIFICATIONS = 'Уведомления о заказах';
export const PAGE_TITLE_SETTINGS_API = 'API';
export const PAGE_TITLE_SETTINGS_TEST_ORDER = 'Тестовый заказ';

// Основные страницы
export const PAGE_TITLE_DASHBOARDS = 'Главная';
export const PAGE_TITLE_PRODUCTS = 'Товары';
export const PAGE_TITLE_COLLECTIONS = 'Коллекции';
export const PAGE_TITLE_ABC_ANALYSIS = 'ABC-анализ';
export const PAGE_TITLE_ORDERS = 'Заказы';
export const PAGE_TITLE_CLIENTS = 'Клиенты';
export const PAGE_TITLE_PROMOACTIONS = 'Акции';
export const PAGE_TITLE_NEWS = 'Блог';
export const PAGE_TITLE_PROMOTION = 'Продвижение';
export const PAGE_TITLE_DESIGN = 'Редактор сайта';
export const PAGE_TITLE_EMAIL_CONSTRUCTOR = 'Дизайн писем';
export const PAGE_TITLE_MENU = 'Меню';
export const PAGE_TITLE_FILTERS = 'Фильтры';
export const PAGE_TITLE_WINDOWS = 'Баннеры и окна';
export const PAGE_TITLE_WINDOWS_PAGE = 'Баннеры и модальные окна';
export const PAGE_TITLE_ADDONS = 'Услуги';
export const PAGE_TITLE_CHECKOUT_EDITOR = 'Оформление заказа';
